import React__default from 'react';
import { useApplicationContext, Application } from '../../../containers/ApplicationContext/index.js';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { ConsumerRichCardEvents } from '../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../containers/RichCardEventEmitter/index.js';
import { OrderState, PaymentVerificationMethod } from '../../../generated/types.js';
import { paymentVerificationRequestRichCard } from '../../../services/richCardFactory.js';
import Check from './check.svg.js';
import { PaymentVerificationMessageComponent } from './PaymentVerificationMessage.generated.js';
import styles from './styles.css.js';
import PaymentVerificationForm from './PaymentVerificationForm/index.js';

var PaymentVerificationMessage = function PaymentVerificationMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var application = useApplicationContext().application;
  var richCardEventEmitter = useRichCardEventEmitter();

  var _b = paymentVerificationRequestRichCard(message),
      orderId = _b.orderId,
      transactionId = _b.transactionId;

  var isConsumer = application === Application.CONSUMER;
  return React__default.createElement(PaymentVerificationMessageComponent, {
    variables: {
      orderId: orderId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.order) {
      var paymentVerificationMethod = data.order.paymentVerificationMethod;
      return React__default.createElement("div", {
        className: styles.messageContent
      }, React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Congratulations on your new purchase! We need to verify your payment information before we can process your order. This is standard fraud protection to make sure you are the cardholder. If you have any questions, don't hesitate to ask your expert or", ' ', React__default.createElement("span", {
        onClick: function onClick() {
          return isConsumer && (richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.VIEW_ORDER_SUPPORT
          }));
        },
        className: isConsumer ? styles.link : undefined
      }, "contact support"), "!"), data.order.state === OrderState.CONSUMER_PAYMENT_COMPLETED ? React__default.createElement("div", {
        className: styles.success
      }, React__default.createElement("div", {
        className: styles.successIcon
      }, React__default.createElement(Check, null)), React__default.createElement("div", {
        className: styles.header
      }, "Payment verified successfully"), React__default.createElement("div", {
        className: styles.instruction
      }, "Thank you for verifying that you are the cardholder, we were able to safely process your order!")) : data.order.state !== OrderState.CONSUMER_PAYMENT_IN_REVIEW ? React__default.createElement("div", {
        className: styles.success
      }, React__default.createElement("div", {
        className: styles.successIcon
      }, React__default.createElement(Check, null)), React__default.createElement("div", {
        className: styles.header
      }, "Payment verification"), React__default.createElement("div", {
        className: styles.instruction
      }, "Your payment is no longer in review!")) : !paymentVerificationMethod ? React__default.createElement("div", {
        className: styles.instruction
      }, "You'll be receiving a call from us soon!") : React__default.createElement("div", {
        className: styles.box
      }, React__default.createElement("div", {
        className: styles.header
      }, "Payment verification required"), paymentVerificationMethod == PaymentVerificationMethod.CODE ? React__default.createElement("div", {
        className: styles.instruction
      }, React__default.createElement("div", null, "Please follow these instructions to verify that you are the cardholder:"), React__default.createElement("ol", {
        className: styles.instructionStepList
      }, React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Access your credit card statement through your bank website or mobile app")), React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Locate your recent transaction with CURATED.COM")), React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Look for the statement descriptor. It will say CURATED.COM XXXXXX (6 random letters and number)")), React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Enter the 6 random letters and numbers below")))) : React__default.createElement("div", {
        className: styles.instruction
      }, React__default.createElement("div", null, "We have placed a temporary hold on your card for an amount slightly higher than your purchase total. Once verified, we will only charge the correct total amount. Please follow the instructions below to verify."), React__default.createElement("ol", {
        className: styles.instructionStepList
      }, React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Access your credit card statement through your bank website or mobile app")), React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Locate your recent transaction with CURATED.COM")), React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Locate the amount of the transaction")), React__default.createElement("li", {
        className: styles.instructionStep
      }, React__default.createElement("span", null, "Enter the amount shown on your statement below ")))), React__default.createElement(PaymentVerificationForm, {
        orderId: orderId,
        verificationMethod: paymentVerificationMethod,
        transactionId: transactionId,
        formClassName: styles.form,
        codeInputClassName: styles.code
      })));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

PaymentVerificationMessage.handlesMessage = function (message) {
  return !!paymentVerificationRequestRichCard(message);
};

export default PaymentVerificationMessage;
//# sourceMappingURL=index.js.map
